import React, { useState, useEffect } from "react";
import Card from "../../components/Card";

import Wrapper from "../../components/Wrapper";

import { getProducts } from "./api";

export default function Products() {
  let selectedProducts = [];
  try {
    const sp = window.localStorage.getItem("SP");
    if (sp) {
      selectedProducts = JSON.parse(sp);
    }
  } catch (error) {}

  const [data, setdata] = useState([]);
  const [page, setpage] = useState(0);
  const [keywords, setkeywords] = useState("");
  useEffect(() => {
    const getData = async () => {
      const response = await getProducts(page, keywords);
      setdata(response);
    };
    getData();
  }, []);

  return (
    <Wrapper>
      <div>
        <input value={keywords} onChange={(e) => setkeywords(e.target.value)} />
        <button
          className="icon"
          onClick={async () => {
            const response = await getProducts(0, keywords);
            setpage(0);
            setdata(response);
          }}
        >
          Search
        </button>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          columnGap: "16px",
        }}
      >
        {data &&
          data.map((d) => <Card d={d} selectedProducts={selectedProducts} />)}
      </div>
      <button
        onClick={async () => {
          const response = await getProducts(page + 1, keywords);
          setdata(response);
          setpage(page + 1);
        }}
      >
        Next
      </button>
    </Wrapper>
  );
}
